import MISAStoreAPI from '@/apis/business/MISAStore/exercise-store-api.js'
import ExerciseReferAPI from '@/apis/business/student/exercise-refer-api.js'
import ELKCourseAPI from '@/apis/business/MISAStore/elk-course-api.js'

import { HttpStatusCode } from '@/common/constant'
import Enumeration from '@/common/enumeration.js'
import { handleMappingAnswer } from '@/views/pages/teacher/storage/create/common/common.js'
const defaultGrade = -1
export default {
  namespaced: true,

  state: {
    // MISA store
    totalExerciseMISA: null, // Tổng số bài tập từ kho MISA
    libraryExercisesMISA: [], // Bài tập từ kho MISA
    listEmisCourses: [],
    totalEMISCourse: 0,
    selectedQuestion: 1, // Index câu hỏi đang được chọn
    exercise: {}, // lấy chi tiết 1 bài tập
    exerciseDetail: {}, // lấy chi tiết 1 bài tập để làm bài
    exerciseDetailType: null, // cập nhật danh sách theo hs
    exerciseLibrary: { // Tham số cho query filter
      GradeID: null, // Khối
      SubjectID: null, // Môn
      SourceID: null, // Chủ đề
      TakeCharge: null, // Miễn phí/mất phí
      Status: null, // Trạng thái : Đã học, chưa học, đang học
      queryText: '' // Text tìm kiếm
    },
    submitExercise: {}, // Dữ liệu dùng submit
    exerciseStoreField: {}, // Dữ liệu được lấy về từ api dùng binding
    fileManager: [], // File manager cho file bài tải lên của học sinh
    exerciseStatus: true, // xét trạng thái lưu nháp
    exerciseSaveDraft: '', // ID của bản ghi bài tập lưu nháp
    isReplay: true, // Học sinh muốn làm lại bài hay không

    isActiveMISAStore: true, // state dùng để active vào tab tham khảo/đã làm
    tabActivePractice: Enumeration.TabActiveStudentPractice.AllCourse, // state dùng để active vào tab tham khảo/đã làm

    // TODO đây là phần state của exercise reference
    totalExerciseRef: null, // Tổng số bài tập từ kho ex reference
    libraryExercisesRef: [], // Bài tập từ kho  ex reference

    // Preview dạng bài tải đề lên
    mainAttachment: null,
    bothAttachment: [], // State dùng để lưu đề bài và lời giải
    isAnswer: false, // Phân biệt giữa active đề bài/lời giải
    questionAttachment: null, // File đề bài
    answerAttachment: null, // File bài làm đang active
    answerAttachments: [], // Danh sách file bài làm học sinh nộp
    correctAnswerAttachment: null, // File lời giải đang active
    correctAnswerAttachments: [], // Danh sách file lời giải giáo viên tải
    exerciseTitle: '', // Tên bài tập
    note: '', // Ghi chú của học sinh
    answerType: 0, // Loại bài tập
    submitDetails: [], // Danh sách chi tiết bài làm
    summaryResults: {}, // Kết quả bài làm
    status: 0,
    questions: [],
    noteDetail: null,
    exercisePreview: {},
    referenceId: null, // Id của học liệu mà học sinh đã sử dụng
    // NVduc
    viewActive: Enumeration.ExerciseActive.Description,
    // Danh sách học liệu liên quan
    relateExercise: [],
    // NVDuc
    exerciseParnets: [],
    exerciseParnetsOld: [],
    totalExercise: 0,
    exerciseParent: { // Tham số cho query filter
      GradeID: defaultGrade, // Khối
      SubjectCode: '', // Môn
      queryText: '' // Text tìm kiếm
    },
    courseDetailActice: {},
    currentPage: Enumeration.Pagination.CurrentPage,
    referId: '', // Id của ExerciseReference trả về

    // PBAC
    exerciseThemeIndex: 0, // theme mặc định giao diện làm bài tập
    isNotDoneExercise: false // học sinh đang làm bài dở hay không
  },

  getters: {

    /**
     * Số lượng câu đã làm
     * @param {*} state
     * @returns
     */
    numberAnswers (state) {
      if (state.exercise.Questions?.length > 0) {
        const listAnswers = state.exercise.Questions
        var count = 0
        listAnswers.forEach(function (item) {
          if (item.Done) {
            count++
          }
        })
      }
      return count
    },

    /**
     * Tổng số câu hỏi
     * @param {*} state
     * @returns
     */
    numberQuestion (state) {
      return state.exercise.QtyQuestion
    },

    /**
     * kiểm tra sẽ show màn hình preview hay màn compare
     */
    checkShowPreview (state) {
      if (state.answerType === Enumeration.AnswerType.Upload) {
        return true
      } else {
        return false
      }
    }
  },

  mutations: {
    clearData (state) {
      state.exerciseStoreField = {}
      state.fileManager = []
      state.submitExercise = {}
    },

    setCourseDetailActice (state, courseDetailActice) {
      state.courseDetailActice = courseDetailActice
    },

    setCurrentPage (state, currentPage) {
      state.currentPage = currentPage
    },
    resetDataParnets (state) {
      state.exerciseParnetsOld = []
      state.exerciseParnets = []
      state.listEmisCourses = []
    },
    setExerciseParnet (state, exerciseParnets) {
      state.exerciseParnetsOld = [...exerciseParnets]
      if (state.exerciseParnetsOld.length === 0) {
        state.exerciseParnets = exerciseParnets
      } else {
        state.exerciseParnets = state.exerciseParnets.concat(state.exerciseParnetsOld)
      }
    },

    // Cập nhật lại tab active
    updateIsActiveMISAStore (state, isActiveMISAStore) {
      state.isActiveMISAStore = isActiveMISAStore
    },

    // Cập nhật lại tab active
    updateTabActivePractice (state, tabActivePractice) {
      state.tabActivePractice = tabActivePractice
    },

    // cập nhật note ở màn chi tiết
    setNoteDetail (state, noteDetail) {
      state.exercise.Note = noteDetail
    },
    // Cập nhật trạng thái Submit
    updateStatusSubmitExercise (state, status) {
      state.submitExercise.Status = status
    },

    // Set bài tập tham khảo từ kho MISA
    setLibraryExerciseMISA (state, libraryExercisesMISA) {
      state.libraryExercisesMISA = libraryExercisesMISA
    },
    // Set bài tập tham khảo từ kho Cộng đồng giáo viên
    setEMISCourse (state, EMISCourses) {
      state.exerciseParnetsOld = [...EMISCourses]
      if (state.exerciseParnetsOld.length === 0) {
        state.exerciseParnetsOld = EMISCourses
      } else {
        state.listEmisCourses = state.listEmisCourses.concat(state.exerciseParnetsOld)
      }
    },

    // Set tổng số bản ghi bài tập tham khảo từ kho MISA
    settotalExerciseMISA (state, totalExerciseMISA) {
      state.totalExerciseMISA = totalExerciseMISA
    },

    // Set tổng số bản ghi bài tập tham khảo từ kho MISA
    setTotalEMISCourse (state, totalEMISCourse) {
      state.totalEMISCourse = totalEMISCourse
    },

    // Clone object dùng để binding và submit
    setExercisePreview (state, exercisePreview) {
      state.exercisePreview = exercisePreview
    },
    // Clone object dùng để binding và submit
    setExerciseStoreField (state, exerciseStore) {
      state.exerciseStoreField = exerciseStore
    },

    // Xét trạng thái lưu nháp bài tập
    setExerciseStatus (state, value) {
      state.exerciseStatus = value
    },

    /**
     * @description cập nhật danh sách lớp theo học sinh
     */
    setExerciseDetailType (state, exerciseDetailType) {
      state.exerciseDetailType = exerciseDetailType
    },

    // lấy chi tiết 1 bài tập để xem chi tiết
    setExerciseByID (state, exercise) {
      state.exercise = exercise
    },

    // cập nhật câu hỏi được chọn
    setSelectedQuestion (state, sortOrder) {
      state.selectedQuestion = sortOrder
    },

    // cập nhật thông tin bài lưu nháp
    setExerciseSaveDraft (state, param) {
      state.exerciseSaveDraft = param
    },

    // cập nhật ghi chú
    updateNoteExercise (state, noteExercise) {
      state.submitExercise.Note = noteExercise
    },

    // cập nhật câu trả lời cho câu hỏi
    updateAnswerForQuestion (state, param) {
      const tmpSubmit = state.submitExercise?.Questions.filter(
        (item) => item.SortOrder === param.sortOrderQuestion
      )
      // Đối với dạng câu hỏi Yes/No
      if (tmpSubmit[0].Type === Enumeration.QuestionType.Yesorno) {
        tmpSubmit[0].Answers.forEach(function (item) {
          if (item.SortOrder === param.sortOrderAnswer) {
            item.Correct = !item.Correct
          } else {
            item.Correct = false
          }
        })
      }

      // Đối với dạng câu hỏi chọn nhiều đáp án
      if (tmpSubmit[0].Type === Enumeration.QuestionType.Select) {
        tmpSubmit[0].Answers.forEach(function (item) {
          if (item.SortOrder === param.sortOrderAnswer) {
            item.Correct = !item.Correct
          }
        })
      }

      // Đối với dạng câu hỏi điền từ vào chỗ trống
      if (tmpSubmit[0].Type === Enumeration.QuestionType.Fill) {
        tmpSubmit[0].Answers.forEach(function (item) {
          if (item.SortOrder === param.sortOrderAnswer) {
            item.Content = param.contentAnswer
            if (param.contentAnswer !== '') {
              item.Correct = true
            } else {
              item.Correct = false
            }
          }
          if (item.Correct === true) {
            tmpSubmit[0].Done = true
          }
        })
      }

      // Đối với dạng câu hỏi tự luận
      if (tmpSubmit[0].Type === Enumeration.QuestionType.Essay) {
        tmpSubmit[0].Answers.forEach(function (item) {
          if (item.SortOrder === param.sortOrderAnswer) {
            item.Content = param.contentAnswer
            item.AnswerAttachment = param.attachItems
            if (param.contentAnswer !== '' || param.attachItems?.length > 0) {
              item.Correct = true
            } else {
              item.Correct = false
            }
          }
        })
      }

      // Đối với dạng câu hỏi nối
      if (tmpSubmit[0].Type === Enumeration.QuestionType.Pairing) {
        tmpSubmit[0].MappingAnswer = param.correctAnswer
        if (tmpSubmit[0].MappingAnswer.length) {
          tmpSubmit[0].Done = true
          tmpSubmit[0].Answers.map(answer => {
            answer.Correct = true
            return answer
          })
        } else {
          tmpSubmit[0].Answers.map(answer => {
            answer.Correct = false
            return answer
          })
        }
      }
      if (tmpSubmit[0].Type === Enumeration.QuestionType.Pairing) { return }
      tmpSubmit[0].Done = false
      // Set lại trạng thái câu hỏi đã được trả lời hay chưa
      tmpSubmit[0].Answers.forEach(function (item) {
        if (item.Correct === true) {
          tmpSubmit[0].Done = true
        }
      })
    },

    /**
     * Cập nhật ID bài lưu nháp và trạng thái làm tiếp theo
     */
    updateSubmitExerciseSaveDraft (state, params) {
      state.exerciseSaveDraft = params.SubmitExerciseID
      state.isReplay = params.IsReplay
    },

    // Cập nhật background

    updateBackgroundExercise (state, url) {
      state.submitExercise.Background = url
    },

    // set chi tiết 1 bài tập để làm bài
    setExerciseDetail (state, exerciseDetail) {
      state.exerciseDetail = exerciseDetail
      // state.exerciseDetail.Note = state?.noteDetail
      state.submitExercise = {
        SubmitExerciseID: state.exerciseSaveDraft,
        ExerciseReferenceID: state.exercise.SourceType === Enumeration.PracticeType.ExerciseStore ? '' : state.exercise.Id,
        ExerciseStoreID: state.exercise.SourceType === Enumeration.PracticeType.ExerciseStore ? state.exercise.Id : '',
        Note: exerciseDetail.Note,
        Status: 0,
        Replay: exerciseDetail.Replay,
        Questions: []
      }
      exerciseDetail.Questions = exerciseDetail.Questions !== undefined ? exerciseDetail.Questions : []
      exerciseDetail.Questions.forEach(question => {
        let ParentQuestion = null
        if (question.ParentID) {
          ParentQuestion = exerciseDetail.ParentQuestions?.find(
            (item) => item.SortOrder === question.ParentID
          )
        } else {
          ParentQuestion = question.ParentQuestion
        }

        const { Type, SortOrder, Done, Content, Attachments, MappingAnswer, MappingAnswerTeacher } = question
        const questionSubmit = {
          Type,
          SortOrder,
          Done,
          Content,
          Attachments,
          Answers: [],
          CorectAnswers: [],
          QtyCorrect: question?.QtyCorrect,
          ParentQuestion,
          MappingAnswerColumnName: MappingAnswer?.AnswerColumnName,
          MappingAnswer: MappingAnswer?.CorrectAnswer || [],
          MappingAnswerTeacher: MappingAnswerTeacher
        }
        /**
         * Care lỗi dữ liệu do bug trước đó từ tính năng trích rút
         * Nếu là câu tự luận và không có đáp án thì push 1 đáp án default vào để binding dữ liệu
         * @modified PBac (24/5/2022)
         * */
        if (!question.Answers?.length && question.Type === Enumeration.QuestionType.Essay) {
          question.Answers.push({
            Correct: false,
            SortOrder: 1
          })
        }
        question.Answers.forEach(function (item) {
          var answer = {
            Correct: item.Correct,
            Content: item.Content,
            Image: item.Image,
            SortOrder: item.SortOrder,
            AnswerAttachment: item.AnswerAttachment,
            Column: item.Column
          }
          questionSubmit.Answers.push(answer)
        })

        question.CorectAnswers?.forEach(function (item) {
          var answer = {
            Correct: item.Correct,
            Content: item.Content,
            Image: item.Image,
            SortOrder: item.SortOrder,
            AnswerAttachment: item.AnswerAttachment
          }
          questionSubmit.CorectAnswers.push(answer)
        })
        state.submitExercise.Questions.push(questionSubmit)
      })
    },
    // TODO đây là phần exercise reference

    // Set bài tập tham khảo từ danh sách bài tập đã làm
    setLibraryExerciseRef (state, libraryExercisesRef) {
      state.libraryExercisesRef = libraryExercisesRef
    },

    // Set tổng số bản ghi bài tập tham khảo từ kho MISA
    settotalExerciseRef (state, totalExerciseRef) {
      state.totalExerciseRef = totalExerciseRef
    },

    /**
     * @description cập nhật danh sách lớp theo học sinh
     */
    setSubmitExercise (state, submitExercise) {
      state.submitExercise = submitExercise
    },

    // Cập nhật ID bài lưu nháp
    updateSubmitExercise (state, submitExercise) {
      state.submitExercise.SubmitExerciseID = submitExercise.submitExerciseID
      state.submitExercise.ExerciseReferenceID = submitExercise.exReferenceID
    },

    setPreviewAttachment (state, param) {
      // file bài làm
      if (param?.AnswerAttachment !== 'undefined') {
        state.mainAttachment = param?.AnswerAttachment[0]
      }
      // file lời giải
      if (param.CorrectAnswerAttachment !== 'undefined' && param.CorrectAnswerAttachment?.length !== 0 &&
        param?.AnswerAttachment.length !== 0) {
        state.bothAttachment = param?.CorrectAnswerAttachment[0]
        state.isAnswer = true
      } else if (state.bothAttachment.length === 0 &&
        param.QuestionAttachment !== 'undefined' &&
        param.CorrectAnswerAttachment.length === 0) { // nếu không có lời giải thì load đề bài lên trước
        state.bothAttachment = param?.QuestionAttachment
      }

      // thêm đề bài
      if (param?.QuestionAttachment !== 'undefined' &&
        param?.QuestionAttachment.length !== 0) {
        state.questionAttachment = param?.QuestionAttachment
      }

      // thêm đáp án
      if (param?.AnswerAttachment !== 'undefined' &&
        param?.AnswerAttachment.length !== 0) {
        state.answerAttachment = param?.AnswerAttachment[0]
        state.answerAttachments = param?.AnswerAttachment
      }

      // thêm lời giải
      if (param?.CorrectAnswerAttachment !== 'undefined' &&
        param?.CorrectAnswerAttachment.length !== 0) {
        state.correctAnswerAttachment = param?.CorrectAnswerAttachment[0]
        state.correctAnswerAttachments = param?.CorrectAnswerAttachment
      }
      // Gán các dữ liệu khác
      state.exerciseTitle = param.Title
      state.note = param.Note
      state.studentExerciseID = param?.StudentExerciseID
      state.answerType = param?.AnswerType
      if (param?.SubmitDetails !== 'undefined') {
        state.submitDetails = param?.SubmitDetails
      }
      state.summaryResults = param?.SummaryResults
      state.status = param?.Status
      state.questions = param?.Questions
    },

    // thực hiện thay đổi lời giải và bài làm khi click vào file
    setBothAttachment (state, param) {
      state.bothAttachment = param
    },

    // cập nhật ID bài tập của học sinh
    updateStudentExerciseID (state, id) {
      state.studentExercise.Id = id
    },

    // set bài làm
    setIsAnswer (state, param) {
      state.isAnswer = param
    },

    // thực hiện thay đổi lời giải khi click vào file
    setCorrectAnswerAttachment (state, param) {
      state.correctAnswerAttachment = param
    },

    // thay đổi bài làm trên preview
    setMainAttachment (state, mainAttachment) {
      state.mainAttachment = mainAttachment
    },

    // thực hiện thay đổi lời giải khi click vào file
    setAnswerAttachment (state, param) {
      state.answerAttachment = param
    },

    /**
     * Cập nhật trạng thái chuyển tab
     * @param {*} state
     * @param {*} viewActive
     */
    updateviewActive (state, viewActive) {
      state.viewActive = viewActive
    },

    /**
     * Cập nhật Id sau khi sử dụng
     * @param {*} state
     * @param {*} referId
     */
    setReferId (state, referId) {
      state.referId = referId
    },

    /**
     * Set học liệu liên quan
     * @param {*} state
     * @param {*} relateExercise
     */
    setRelateExercise (state, relateExercise) {
      state.relateExercise = relateExercise
    },

    setTotalExerciseParnet (state, total) {
      state.totalExercise = total
    },

    // Cập nhật theme làm bài tập
    updateExerciseThemeIndex (state, exerciseThemeIndex) {
      state.exerciseThemeIndex = exerciseThemeIndex
    },

    // Cập nhật state lưu học sinh đang làm bài dở hay không
    updateIsNotDoneExercise (state, isNotDoneExercise) {
      state.isNotDoneExercise = isNotDoneExercise
    }
  },

  actions: {

    /**
     * Lấy toàn bộ thư viện học liệu tham khảo của MISA
     * @param {} context
     * @param {*} exerciseLibrary
     * @returns
     * @author PBac
     */
    getFilterExerciseStore (context, exerciseLibrary) {
      return new Promise((resolve, reject) => {
        MISAStoreAPI.getAsync('emis-courses', { params: exerciseLibrary })
          .then((res) => {
            context.commit('setLibraryExerciseMISA', res.Data?.PageData)
            context.commit('settotalExerciseMISA', res.Data?.Total)
            resolve(res.Data?.PageData)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy toàn bộ thư viện học liệu tham khảo của MISA
     * @param {} context
     * @param {*} exerciseLibrary
     * @returns
     * @author PBac
     */
    getFilterExerciseStoreRecommend (context, exerciseLibrary) {
      return new Promise((resolve, reject) => {
        MISAStoreAPI.getAsync('emis-course-recommend', { params: exerciseLibrary })
          .then((res) => {
            context.commit('setLibraryExerciseMISA', res.Data?.PageData)
            context.commit('settotalExerciseMISA', res.Data?.Total)
            resolve(res.Data?.PageData)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy toàn bộ thư viện học liệu tham khảo của MISA
     * @param {} context
     * @param {*} exerciseLibrary
     * @returns
     * @author PBac
     */
    getFilterEMISCourses (context, exerciseLibrary) {
      return new Promise((resolve, reject) => {
        ELKCourseAPI.getAsync('list-exercise-practice', { params: exerciseLibrary })
          .then((res) => {
            context.commit('setEMISCourse', res.Data?.PageData)
            context.commit('setTotalEMISCourse', res.Data?.Total)
            resolve(res.Data?.PageData)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    // cập nhật id submitexercise lưu nháp
    updateSubmitExerciseSaveDraft (context, params) {
      context.commit('updateSubmitExerciseSaveDraft', params)
    },

    async getStudentExerciseQuestion (context, params) {
      const res = await ExerciseReferAPI.getAsync(
        `/do?id=${params.id}&submitExercisesID=${params.submitExercisesID}`
      )
      if (res.IsSuccess && res.Code === HttpStatusCode.OK) {
        context.commit('setExerciseStoreField', res.Data)
      }
    },

    /**
     * @description Gọi service submit bài làm của học sinh
     * @param {*} context
     * @param {*} submitExercise
     * @returns
     * @author PBac
     */
    addStudentExerciseQuestion (context, submitExercise) {
      return new Promise((resolve, reject) => {
        ExerciseReferAPI.postAsync('submit', submitExercise)
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * Cập nhật thông tin tab đang active
     * @param {*} context
     * @param {*} params
     */
    updateNoteExercise (context, noteExercise) {
      context.commit('updateNoteExercise', noteExercise)
    },

    /**
     * Cập nhật đáp án cho từng câu hỏi
     * @param {*} context
     * @param {*} params
     */
    updateAnswerForQuestion (context, params) {
      context.commit('updateAnswerForQuestion', params)
      context.commit('setSelectedQuestion', params.sortOrderQuestion)
    },

    /**
     * lấy chi tiết thông tin của phiếu bài tập để làm bài
     */
    getExerciseDetail (context, params) {
      const query =
      `&id=${params.id ? params.id : ''}` +
      `&submitExercisesID=${params.submitExercisesID ? params.submitExercisesID : ''}`
      return new Promise((resolve, reject) => {
        ExerciseReferAPI.getAsync('do?' + query).then(res => {
          const exercise = handleMappingAnswer(res.Data, Enumeration.HandlePairingAnswerType.Revert)
          context.commit('setExerciseDetail', exercise)
          resolve(res.Data)
        }).catch((err) => {
          reject(err)
        })
      })
    },
    // TODO phần của exercise reference

    /**
     * Cập nhật trạng thái bài nộp là lưu nháp hay nộp bài
     * @param {*} context
     * @param {*} status
     */
    updateStatusSubmitExercise (context, status) {
      context.commit('updateStatusSubmitExercise', status)
    },
    /**
     * Lấy toàn bộ thư viện học liệu tham khảo của MISA
     * @param {} context
     * @param {*} exerciseLibrary
     * @returns
     * @author TTdung
     */
    getFilterExerciseReference (context, exerciseLibrary) {
      const query =
          `gradeID=${exerciseLibrary.GradeID ? exerciseLibrary.GradeID : ''}` +
          `&subjectID=${exerciseLibrary.SubjectID ? exerciseLibrary.SubjectID : ''}` +
          `&topicID=${exerciseLibrary.TopicID ? exerciseLibrary.TopicID : ''}` +
          `&queryText=${exerciseLibrary.queryText ? exerciseLibrary.queryText : ''}` +
          `&pageIndex=${exerciseLibrary.pageIndex ? exerciseLibrary.pageIndex : ''}` +
          `&pageSize=${exerciseLibrary.pageSize ? exerciseLibrary.pageSize : ''}`
      return new Promise((resolve, reject) => {
        ExerciseReferAPI.getAsync('exercise-references?' + query)
          .then((res) => {
            context.commit('setLibraryExerciseRef', res.Data?.PageData)
            context.commit('settotalExerciseRef', res.Data?.Total)
            resolve(res.Data?.PageData)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * lấy chi tiết 1 bài tập đã làm
     */
    getExercisePracticeDetail (context, params) {
      const query =
          `id=${params.id ? params.id : ''}` +
          `&sourceType=${params.sourceType ? params.sourceType : ''}`
      return new Promise((resolve, reject) => {
        ExerciseReferAPI.getAsync('detail?' + query).then((res) => {
          context.commit('setExerciseByID', res.Data)
          resolve(res.Data)
        })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description hàm submit exercise
     * @param {*} context
     * @param {*} exerciseStoreField
     * @returns
     */
    submitStudentExercise (context, submitExercise) {
      return new Promise((resolve, reject) => {
        const exercise = handleMappingAnswer(submitExercise, Enumeration.HandlePairingAnswerType.Convert)
        ExerciseReferAPI.postAsync('/submit', exercise)

          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Cập nhật SubmitExerciseId sau khi lưu nháp thành công
     */
    updateSubmitExercise (context, submitExercises) {
      context.commit('updateSubmitExercise', submitExercises)
    },

    /**
     * preview 1 bài tập đã làm hoặc vừa hoàn thành xong
     * @param {} context
     * @param {*} exerciseLibrary
     * @returns
     * @author TTdung
     */
    getExerciseReferenceReview (context, params) {
      const query =
          `exerciseReferenceID=${params.exerciseReferenceID ? params.exerciseReferenceID : ''}` +
          `&submitExercisesID=${params.submitExercisesID ? params.submitExercisesID : ''}`
      return new Promise((resolve, reject) => {
        ExerciseReferAPI.getAsync('preview?' + query)
          .then((res) => {
            const exercise = handleMappingAnswer(res.Data, Enumeration.HandlePairingAnswerType.Revert)
            context.commit('setExercisePreview', exercise)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Lấy dữ liệu các file preview từ học sinh làm bài
     * @param {*} context
     * @param {*} params
     * @returns
     * @author PBac
     */
    getPreviewAttachmentStudent (context, params) {
      return new Promise((resolve, reject) => {
        ExerciseReferAPI.getAsync('preview', { params: params }
        ).then((res) => {
          context.commit('setPreviewAttachment', res.Data)
          resolve(res)
        }).catch((err) => {
          reject(err)
        })
      })
    },

    /**
     * Cập nhật trạng thái
     * CreateBy:NVDuc 15.09
     */
    updateviewActive (context, viewActive) {
      context.commit('updateviewActive', viewActive)
    },

    /**
     * @author VHSon
     * @param {*} context
     * @param {*} exerciseId
     * @returns
     * @description thêm mới
     */
    async insertExerciseRefer (context, exerciseId) {
      return new Promise((resolve, reject) => {
        ExerciseReferAPI.postAsync('use-exercise', exerciseId)
          .then((res) => {
            context.commit('setReferId', res.Data)
            resolve(res)
          }).catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy danh sách học liệu liên quan
     * @param {} context
     * @param {*} exerciseRelate
     * @returns
     * @author VHSON
     */
    getExerciseRelate (context, exerciseRelate) {
      const query =
              `gradeId=${exerciseRelate.gradeId ? exerciseRelate.gradeId : ''}` +
              `&exerciseId=${exerciseRelate.exerciseId ? exerciseRelate.exerciseId : ''}`
      return new Promise((resolve, reject) => {
        MISAStoreAPI.getAsync('relate-exercises?' + query)
          .then((res) => {
            context.commit('setRelateExercise', res.Data)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Get danh sách học liệu của đối tác theo điều kiện
     * @author NVDuc
     * @param {*} contextp
     * @param {*} exerciseParnets
     * @returns
     */
    getExerciseParnet (context, exerciseParnets) {
      // const query =
      //         `gradeId=${exerciseParnets.gradeId ? exerciseParnets.gradeId : ''}` +
      //         `&subjectID=${exerciseParnets.subjectID ? exerciseParnets.subjectID : ''}` +
      //         `&queryText=${exerciseParnets.queryText ? exerciseParnets.queryText : ''}` +
      //         `&sourceType=${exerciseParnets.sourceType ? exerciseParnets.sourceType : ''}` +
      //         `&pageIndex=${exerciseParnets.pageIndex ? exerciseParnets.pageIndex : ''}` +
      //         `&pageSize=${exerciseParnets.pageSize ? exerciseParnets.pageSize : ''}`
      return new Promise((resolve, reject) => {
        ELKCourseAPI.getAsync('list-exercise-parnets', { params: exerciseParnets })
          .then((res) => {
            context.commit('setExerciseParnet', res.Data?.PageData)
            context.commit('setTotalExerciseParnet', res.Data?.Total)

            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy danh sách học liệu đối tác giới thiệu cho học sinh tiếp tục học tập
     * @author PBac
     * @param {*} context
     * @param {*} exerciseParnets
     * @returns
     */
    getExercisePartnerByFilter (context, exercisePartnerParams) {
      return new Promise((resolve, reject) => {
        ELKCourseAPI.getAsync('exercise-partner', { params: exercisePartnerParams })
          .then((res) => {
            context.commit('setExerciseParnet', res.Data?.PageData)
            context.commit('setTotalExerciseParnet', res.Data?.Total)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Sửa ghi chú của học sinh
     * @author PBac
     * @param {*} context
     * @param {*} classroom
     * @returns
     */
    updateNoteExerciseById (context, params) {
      const bodyUpdate = {
        Id: params.Id,
        Note: params.Note,
        UpdateFields: ['Note']
      }
      return new Promise((resolve, reject) => {
        ExerciseReferAPI.putAsync(`/${params.Id}`, bodyUpdate)
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
